export const SERVICE_LIST = [
    {
        img: "https://c.animaapp.com/HwA6Ml4A/img/overlay-4.svg",
        title: "Free Support",
        desc: "Get full support for your university applications – from editing personal statements to organising all required documents and timelines.",
        route: "/personalised-guidence/free",
    },
    {
        img: "https://c.animaapp.com/HwA6Ml4A/img/overlay-5.svg",
        title: "Premium Application Service",
        desc: "Receive complete, premium-level assistance with your application process – document review, personal statement polish, and timely submission.",
        route: "/end-to-end-app-service/2",
        payment: {
            levelBased: false,
            link: "https://square.link/u/pjjfIFm6",
        }
    },
    {
        img: "https://c.animaapp.com/HwA6Ml4A/img/overlay-6.svg",
        title: "Visa",
        desc: "Get step-by-step support throughout the visa process – from preparing paperwork to submitting your visa application smoothly.",
        route: "/visa-assistance/2",
        payment: {
            levelBased: false,
            link: "https://square.link/u/NWqf2KR4",
        }
    },
    {
        img: "https://c.animaapp.com/HwA6Ml4A/img/overlay.svg",
        title: "Oxbridge",
        desc: "Specialised mentoring for Oxford, Cambridge, and other leading Global universities – including interview training and strategy sessions.",
        route: "/university-preparation/2",
        payment: {
            levelBased: true,
            links: [
                {
                    level: "Undergraduate",
                    link: "https://square.link/u/2lRS0F2j"
                },
                {
                    level: "Postgraduate",
                    link: "https://square.link/u/vko4magv"
                },
                {
                    level: "PhD",
                    link: "https://square.link/u/UmxTUvAM"
                }
            ]
        }
    },
    {
        img: "https://c.animaapp.com/HwA6Ml4A/img/overlay-1.svg",
        title: "Medicine",
        desc: "Strengthen your application for medicine, dentistry, or veterinary courses with expert interview coaching and feedback.",
        route: "/medical-school-support/2",
        payment: {
            levelBased: false,
            link: "https://square.link/u/nFdl4CZ5",
        }
    },
    {
        img: "https://c.animaapp.com/HwA6Ml4A/img/overlay-2.svg",
        title: "Art and Design",
        desc: "Get personalised advice and feedback from experienced artists to craft an outstanding art or design portfolio.",
        route: "/creative-portfolio-guidance/2",
        payment: {
            levelBased: false,
            link: "https://square.link/u/uySgE1cm",
        }
    },
    {
        img: "https://c.animaapp.com/HwA6Ml4A/img/overlay-3.svg",
        title: "PhD",
        desc: "Build a strong research proposal and connect with the right supervisor through dedicated, one-on-one PhD support.",
        route: "/phd-application-mentorship/2",
        payment: {
            levelBased: false,
            link: "https://square.link/u/UmxTUvAM",
        }
    },
];